export const SHOW_ACCESS_DENIED_NOTIFICATION = 'SHOW_ACCESS_DENIED_NOTIFICATION'
export const GET_NOTIFICATION_MESSAGE = 'GET_NOTIFICATION_MESSAGE'
export const GET_NOTIFICATION_MESSAGE_ERROR = 'GET_NOTIFICATION_MESSAGE_ERROR'
export const SHOW_NOT_FOUND_NOTIFICATION = 'SHOW_NOT_FOUND_NOTIFICATION'
export const SHOW_ERROR_TOKEN_NOTIFICATION = 'SHOW_ERROR_TOKEN_NOTIFICATION'
export const SHOW_FORBIDDEN_NOTIFICATION = 'SHOW_FORBIDDEN_NOTIFICATION'
